export const I18n = {
	'en': {
		main: {
			title: 'Main Content'
		},
		guest: {
			title: 'Guest Main Content'
		},
		developer: {
			title: 'Developer Content'
		},
		userIsNotActive: 'The user is not active',
	},
	'ru': {
		main: {
			title: 'Главный контент'
		},
		guest: {
			title: 'Гостевой контент'
		},
		developer: {
			title: 'Страница разработчика'
		},
		userIsNotActive: 'Пользователь не активен',
	},
	'sk': {
		main: {
			title: 'Hlavný obsah'
		},
		guest: {
			title: 'Obsah pre hostí'
		},
		developer: {
			title: 'Developer Content'
		},
		userIsNotActive: 'Používateľ nie je aktívny',

	}
};



// WEBPACK FOOTER //
// ./src/I18n/layouts/layout.js